import Router from "vue-router"
import Vue from "vue"
Vue.use(Router)
import routes from "./routes"



const router = new Router({
    routes,
})

export default router